import { render, staticRenderFns } from "./DestinationAddressSearchBox.vue?vue&type=template&id=a927b81e"
import script from "./DestinationAddressSearchBox.vue?vue&type=script&lang=js"
export * from "./DestinationAddressSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports